import { createIconComponent } from '../../factory/create-icon-component';
export const ArrowDownShortIcon = createIconComponent(
  'ArrowDownShortIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9L9.73726 12.7373C10.5293 13.5293 10.9253 13.9253 11.382 14.0737C11.7837 14.2042 12.2163 14.2042 12.618 14.0737C13.0747 13.9253 13.4707 13.5293 14.2627 12.7373L18 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
